import 'react-app-polyfill/stable';
import 'core-js';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { IntlProvider } from 'react-intl-number-format';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './states/store';

const intlConfig = {
	locale: 'pt-BR',
	options: {
		currency: 'BRL',
		maximumFractionDigits: 2,
	},
};

const Root = () => {
	return (
		<Provider store={store}>
			<PersistGate persistor={persistor}>
				<IntlProvider config={intlConfig}>
					<App />
				</IntlProvider>
			</PersistGate>
		</Provider>
	);
};

createRoot(document.getElementById('root')).render(<Root />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
